// extracted by mini-css-extract-plugin
var _1 = "RequestProfileTabInternalTasksSkeleton-moduleRequestProfileTabInternalTasksSkeleton__wryn0";
var _2 = "RequestProfileTabInternalTasksSkeleton-modulechecklist___zY9u";
var _3 = "RequestProfileTabInternalTasksSkeleton-moduleheader__jlZ_X Skeleton-moduleSkeleton__Mlrfv";
var _4 = "RequestProfileTabInternalTasksSkeleton-moduleitem__bjN7W Skeleton-moduleSkeleton__Mlrfv";
var _5 = "RequestProfileTabInternalTasksSkeleton-moduleitems__asz2Z";
export { _1 as "RequestProfileTabInternalTasksSkeleton", _2 as "checklist", _3 as "header", _4 as "item", _5 as "items" }
